<template>
  <div>
    <div class="row">
      <div class="col-12 mt-3">
        <Card body-classes="p-3" card-classes="shadow-sm">
          <template #header>
            <div class="d-flex flex-row align-items-center justify-content-between">
              <h5 class="mb-0 text-primary">
                <vue-feather type="bar-chart-2" class="me-2"></vue-feather>
                Annual Sales Summary
              </h5>
              <div class="d-flex align-items-center">
                <label for="yearSelect" class="me-2 text-muted">Select Year:</label>
                <select id="yearSelect" class="form-select form-select-sm w-auto" v-model="summaryDuration">
                  <option v-for="year in analytics.years" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
            </div>
          </template>
          <div>
            <div v-if="loading" class="text-center py-5">
              <Spinner spinner-class="mb-1" />
              <p class="text-muted mt-2">Loading annual sales data...</p>
            </div>
            <div v-else>
              <!-- Summary Cards -->
              <div class="row g-3 mb-4">
                <div class="col-lg-4 col-md-4 col-sm-12" v-for="(item, index) in infoCols" :key="index">
                  <div class="card h-100 border-0 shadow-sm">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <div class="rounded-circle p-3 me-3" :class="`bg-${item.bg}-light`">
                          <vue-feather :type="item.icon" :stroke="item.color" size="24"></vue-feather>
                        </div>
                        <div>
                          <h6 class="mb-0">{{ item.title }}</h6>
                          <small class="text-muted">Year {{ summaryDuration }}</small>
                        </div>
                      </div>
                      <div class="mt-3">
                        <h3 :class="`text-${item.bg}`">{{ item.value }}</h3>
                        <div class="progress mt-2" style="height: 5px;">
                          <div class="progress-bar" :class="`bg-${item.bg}`" role="progressbar"
                               :style="{width: getProgressWidth(index)}"
                               aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Chart -->
              <div class="card border-0 shadow-sm">
                <div class="card-body">
                  <h6 class="text-muted mb-3">Monthly Sales Trend ({{ summaryDuration }})</h6>
                  <LineChart
                      :data="this.analytics.store.datasets"
                      :labels="this.analytics.store.labels"
                  ></LineChart>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import {decrypt} from "@/utils/crypto";
import analyticsService from "@/api/analyticsService";
import LineChart from "@/components/charts/LineChart.vue";
import formatNumber from "@/utils/formatNumber";

export default {
  name: "AnnualAnalytics",
  components: {LineChart},

  data(){
    return {
      profile: {},
      store: {},
      loading: true,
      analytics: {
        years: [],
        store: {
          labels: [],
          datasets: []
        },
        sales: {}
      },
      summaryDuration: new Date().getFullYear(),
    }
  },

  methods: {
    async getAnalytics() {
      this.loading = true
      this.analytics = await analyticsService.getStoreAnalytics(this.store.id, this.summaryDuration)
      this.loading = false
    },

    getProgressWidth(index) {
      // Calculate relative percentages for progress bars
      if (!this.analytics.sales || !this.infoCols || this.infoCols.length === 0) {
        return '0%';
      }

      const values = this.infoCols.map(item => {
        const numValue = parseFloat(item.value.replace(/[^0-9.-]+/g, ''));
        return isNaN(numValue) ? 0 : numValue;
      });

      const maxValue = Math.max(...values);
      if (maxValue === 0) return '0%';

      const currentValue = values[index];
      return `${(currentValue / maxValue * 100).toFixed(0)}%`;
    }
  },

  computed: {
    infoCols() {
      return [
        {
          title:'Sales (' + this.analytics.sales.count + ')',
          value:formatNumber(this.analytics.sales.total - this.analytics.sales.discount, false),
          icon:"dollar-sign",
          color:"darkviolet",
          bg:'primary',
        },
        {
          title:'Tax',
          value:formatNumber(this.analytics.sales.tax, false),
          icon:"pie-chart",
          color:"crimson",
          bg:'secondary',
        },
        {
          title:'Discount',
          value:formatNumber(this.analytics.sales.discount, false),
          icon:"percent",
          color:"gray",
          bg:'default',
        },
      ]
    },
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    this.store = JSON.parse(decrypt(sessionStorage.getItem('store')))
    await this.getAnalytics()
  },

  watch: {
    summaryDuration: async function () {
      await this.getAnalytics()
    }
  },

}
</script>

<style scoped>

</style>
